module.exports = __webpack_public_path__ + "assets/icons-flags-canda.a4e3e7e1.svg";